import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyNBMPerformanceReportPage: LoadableType<
	Omit<
		{
			scanId?: string;
		},
		'flags'
	>
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NBMPerformanceReportPage" */ './NBMPerformanceReportPage.tsx'
			)
		).NBMPerformanceReportPage,
});
